const OrderToPayloadDietDays = (date: Date): IOrderPayloadDietDay => ({
	date: dateToFilterFormat(date),
	addon_slots: [],
	meal_slots: [],
})

const OrderToPayloadCartDietDayConfigMealSlot = (
	data: IOrderDaysMealFormModel,
	selectedDietGroup: EDietGroup | undefined,
): IOrderPayloadCartDietDayConfigMealSlot => {
	const { mealType, sizeID, variantID } = data

	const isKidsMenu = selectedDietGroup === EDietGroup.KIDS_MENU

	return {
		meal_type: mealType,
		size_id: sizeID,
		meal_category: EMealCategory.MEAL,
		meal_kind: EMealKind.MEAL,
		meal_subkind: isKidsMenu ? EMealSubKind.KIDS : null,
		variant_id: variantID ?? null,
	}
}

export const resolveSizeID = (
	mealType: EMealType,
	calorie: number,
	selectedDietMatrices: IDietMatriceModel[] | undefined,
): number | null => {
	const matrix = selectedDietMatrices?.find(m => m.kcal === calorie && m.mealType === mealType)
	return matrix?.sizeID || null
}

const OrderToPayloadCartDietDayConfig = (
	data: IOrderDayFormModel[],
	kcal: number,
	dietID: number,
	selectedDietGroup: EDietGroup | undefined,
): IOrderPayloadCartDietDayConfig => {
	const mealSlots = data[0]?.mealSlots ?? []

	return {
		kcal,
		uuid: null,
		diet_id: dietID,
		meal_slots: mealSlots
			? mealSlots.map(slot => OrderToPayloadCartDietDayConfigMealSlot(slot, selectedDietGroup))
			: [],
	}
}

const OrderToPayloadShared = (
	event: IFormSubmitEvent<IClientOrderManageFormModel>,
	others: IClientOrderPayloadOther,
): IOrderPayloadShared => {
	const { selectedDietID, calorie, addressID, status, discountCode, name } = event.values

	const {
		selectedClientId,
		mealKind,
		selectedDays,
		selectedDietType,
		selectedDietGroup,
		selectedDietMatrices,
		numberOfMeals,
	} = others

	const isKidsMenu = selectedDietGroup === EDietGroup.KIDS_MENU

	const days: IOrderDayFormModel[] = []
	selectedDays.forEach(day => {
		const obj: any = { date: dateToFilterFormat(day) }

		if (selectedDietType === EDietType.MENU_SELECTION) {
			obj.mealSlots = Object.entries(numberOfMeals).flatMap(([key, value]) => {
				const quantity = value.value

				if (quantity <= 0) return []

				const mealType = EMealType[key.toUpperCase() as keyof typeof EMealType]

				const sizeID = isKidsMenu
					? kidsMenuMealSizeMap[mealType]
					: resolveSizeID(mealType, calorie, selectedDietMatrices)

				return Array.from({ length: quantity }).fill({ sizeID, mealType })
			})
		}

		days.push(obj)
	})

	return {
		status,
		diet_id: selectedDietID,
		diet_nickname: name,
		client_id: selectedClientId,
		address_id: addressID,
		meal_kind: mealKind,
		code: discountCode,
		kcal: calorie,
		include_sundays: false,
		include_saturdays: false,
		diet_days: selectedDays ? selectedDays.map(OrderToPayloadDietDays) : [],
		cart_diet_config: days
			? OrderToPayloadCartDietDayConfig(days, calorie, selectedDietID, selectedDietGroup)
			: null,
		parent_client_diet_uuid: null,
	}
}

export const OrderRefundCalculate = (json: IOrderRefultDetails): IOrderRefultDetailsModel => {
	const { refund_amount, cancelled_days } = json
	return {
		refundAmount: refund_amount,
		cancelledDayUuids: cancelled_days,
	}
}

export const OrderToPayloadCreate = (
	event: IFormSubmitEvent<IClientOrderManageFormModel>,
	others: IClientOrderPayloadOther,
): IOrderPayloadCreate => {
	const shared = OrderToPayloadShared(event, others)

	return {
		...shared,
	}
}

export const OrderToPayloadUpdate = (
	updated: IOrderModel,
	event: IFormSubmitEvent<IClientOrderManageFormModel>,
	others: IClientOrderPayloadOther,
): IOrderPayloadUpdate => {
	const shared = OrderToPayloadShared(event, others)

	return {
		...shared,
		parent_client_diet_uuid: updated.uuid,
	}
}
